import { render, staticRenderFns } from "./follow.vue?vue&type=template&id=66d97f85&scoped=true"
import script from "./follow.vue?vue&type=script&lang=js"
export * from "./follow.vue?vue&type=script&lang=js"
import style0 from "./follow.vue?vue&type=style&index=0&id=66d97f85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d97f85",
  null
  
)

export default component.exports